import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { ReactComponent as At } from '../assets/svg/at.svg';
import Button from './Button';
import Notification from './Notification';
import Input from './Input';
import { Link } from 'react-router-dom';
import UserAPI from '../apis/UserAPI';
import { isValidEmail } from '../helpers/validators';
import Modal from './Modal';
import StampMessage from './StampMessage';
import { useHistory } from 'react-router-dom';

const Recover = () => {
  let history = useHistory();

  const [email, setEmail] = useState('');
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showState, setShowState] = useState(false);

  const recover = () => {
    if (loading) return;

    setLoading(true);

    const sanitized = {
      email: email.replace(/\s/g, '').toLowerCase(),
    };

    let notification = null;
    if (!isValidEmail(sanitized.email)) notification = 'El correo es inválido.';

    if (notification) {
      setNotification(notification);
      setLoading(false);
    } else {
      setNotification(null);
      UserAPI.sendPasswordReset(sanitized.email)
        .then(() => {
          setLoading(false);
          setShowState('SUCCESS');
        })
        .catch((error) => {
          setShowState('FAILURE');
          setNotification(error);
          setLoading(false);
        });
    }
  };

  const ModalState = (
    <ModalStyled>
      <ContainerState>
        {showState === 'SUCCESS' && (
          <StampMessage
            success
            text='Se envió un mensaje a
          tu correo'
          />
        )}
        {showState === 'FAILURE' && (
          <StampMessage wrong text='Ocurrió un error' />
        )}
        <ButtonState
          text='OK'
          tertiary
          onClick={() => {
            if (showState === 'SUCCESS') history.push('/login');
            else if (showState === 'FAILURE') setShowState(false);
          }}
          loading={loading}
        />
      </ContainerState>
    </ModalStyled>
  );

  return (
    <Container>
      {showState && ModalState}
      <Wrapper>
        <Title>Recuperar contraseña</Title>
        <Description>
          Te enviaremos un mensaje a tu correo electrónico con instrucciones.
        </Description>
        {notification && <NotificationStyled message={notification} />}
        <InputStyled
          placeholder='Correo'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          icon={<InputIcon as={At} />}
        />
        <Buttons>
          <ButtonStyled as={ButtonLink} to='/login' text='Atrás' secondary />
          <ButtonStyled
            text='Enviar'
            onClick={recover}
            loading={loading}
            primary
          />
        </Buttons>
      </Wrapper>
    </Container>
  );
};


const Container = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
`;

const Title = styled.div`
  align-self: flex-start;
  font-size: 1.5em;
  font-weight: 600;

  margin-bottom: 15px;
`;

const Description = styled.div`
  align-self: flex-start;
  font-size: 0.9em;

  margin-bottom: 25px;
`;

const NotificationStyled = styled(Notification)`
  margin: 0px 0px 20px 0px;
`;

const InputStyled = styled(Input)`
  margin-bottom: 10px;
`;

const Wrapper = styled.div`
  margin: auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 270px;
  width: 100%;

  padding: 5px;
  box-sizing: border-box;
`;

const InputIcon = styled.div`
  padding: 8px 10px;
  min-width: 18px;
  min-height: 18px;
  width: 18px;
  height: 18px;
  margin: auto 0;
  fill: rgba(0, 0, 0, 0.5);

  ${(props) =>
    props.button &&
    css`
      cursor: pointer;
    `}
`;

const ButtonLink = (props) => <Button as={Link} {...props} />;

const ButtonStyled = styled(Button)`
  margin: 15px 0px;
`;

const Buttons = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 240px) {
    flex-wrap: wrap;
    flex-direction: column-reverse;
    justify-content: center;
  }
`;

const ModalStyled = styled(Modal)`
  max-width: 220px;
  width: 100%;
`;

const ContainerState = styled.div`
  padding: 20px;
  & > * {
    margin: 5px;
  }
`;

const ButtonState = styled(Button)`
  margin-top: 30px;
`;

export default Recover;
